import React, { useState } from 'react';
import axios from 'axios';
import { Form, Input, Button, Checkbox, message, Card, Row, Col, Typography,Rate } from 'antd';
import { API_BASE_URL } from '../../utils/BaseUrl';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const workoutTypeOptions = [
  { label: 'Aerobic', value: 1 },
  { label: 'Boxing', value: 2 },
  { label: 'Cycling', value: 3 },
  { label: 'Fitness', value: 4 },
  { label: 'Functional', value: 5 },
  { label: 'Group X', value: 6 },
  { label: 'Tiktok Dance', value: 7 },
  { label: 'Yoga', value: 8 },
  { label: 'Weightlifting', value: 9 },
  { label: 'Indoor Cycling', value: 10 },
  // Thêm các loại khác nếu có
];

const CreateGymForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
  setLoading(true);
  try {
    // Gọi API geocoding để lấy lat/lng từ địa chỉ
    const geoRes = await axios.get('https://nominatim.openstreetmap.org/search', {
      params: {
        q: values.address,
        format: 'json',
        limit: 1,
      },
    });

    if (!geoRes.data || geoRes.data.length === 0) {
      message.error('Không tìm thấy tọa độ cho địa chỉ này!');
      setLoading(false);
      return;
    }

    const { lat, lon } = geoRes.data[0];

    const payload = {
      Name: values.name,
      Description: values.description,
      Address: values.address,
      Latitude: parseFloat(lat),
      Longitude: parseFloat(lon),
      OpeningHours: values.openingHours,
      PhoneNumber: values.phoneNumber,
      Website: values.website,
      MainImage: values.mainImage,
      Is24h: values.is24h || false,
      Features: values.features,
      Rating: values.rating || 0,
      WorkoutTypes: (values.workoutTypes || []).map((id) => ({ WorkoutTypeId: id })),
    };

    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user')).userId;

    const response = await axios.post(
      `${API_BASE_URL}/api/Gym/newGyms?userId=${user}`,
      payload
    );
    const gymId = response.data.gymId;

    message.success('Tạo phòng gym thành công! Đang chuyển đến trang tạo gói tập...');
      navigate(`/create-package/${gymId}`);
    } catch (err) {
      message.error('Tạo phòng gym thất bại: ' + (err.response?.data?.message || err.message));
    }
  setLoading(false);
};


  return (
    <Row justify="center" style={{ marginTop: 32 }}>
      <Col xs={24} sm={20} md={16} lg={12}>
        <Card bordered style={{ borderRadius: 12, boxShadow: '0 4px 24px #ff980033' }}>
          <Title level={3} style={{ color: '#FF9800', textAlign: 'center', marginBottom: 24 }}>
            Tạo Phòng Fitness Mới
          </Title>
          <Form
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ is24h: false, workoutTypes: [] }}
          >
            <Form.Item label="Tên phòng gym" name="name" rules={[{ required: true, message: 'Vui lòng nhập tên gym!' }]}>
              <Input placeholder="Nhập tên phòng gym" />
            </Form.Item>
            <Form.Item label="Mô tả" name="description">
              <Input.TextArea rows={3} placeholder="Mô tả về phòng gym" />
            </Form.Item>
            <Form.Item label="Khu vực" name="address">
              <Input placeholder="Nhập khu vực: vd: Hòa hải, Ngũ Hành Sơn" />
            </Form.Item>
            {/* <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Vĩ độ (Latitude)" name="latitude">
                  <Input type="number" step="any" placeholder="Vĩ độ" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Kinh độ (Longitude)" name="longitude">
                  <Input type="number" step="any" placeholder="Kinh độ" />
                </Form.Item>
              </Col>
            </Row> */}
            <Form.Item label="Giờ mở cửa" name="openingHours">
              <Input placeholder="Ví dụ: 6:00 - 22:00" />
            </Form.Item>
            <Form.Item label="Số điện thoại" name="phoneNumber">
              <Input placeholder="Nhập số điện thoại" />
            </Form.Item>
            <Form.Item label="Website" name="website">
              <Input placeholder="Nhập website (nếu có)" />
            </Form.Item>
            <Form.Item label="Ảnh đại diện (URL)" name="mainImage">
              <Input placeholder="Dán link ảnh đại diện" />
            </Form.Item>
            <Form.Item name="is24h" valuePropName="checked">
              <Checkbox>Hoạt động 24/7</Checkbox>
            </Form.Item>
            <Form.Item label="Tiện ích nổi bật" name="features">
              <Input.TextArea rows={2} placeholder="Ví dụ: Wifi, Bãi đỗ xe, ..." />
            </Form.Item>
            <Form.Item label="Đánh giá ban đầu" name="rating">
              <Rate allowHalf />
          </Form.Item>

            <Form.Item label="Loại hình tập luyện" name="workoutTypes">
              <Checkbox.Group options={workoutTypeOptions} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block style={{ background: '#FF9800', border: 'none' }}>
                Tạo phòng gym
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default CreateGymForm;
